import { useState, useEffect, useRef } from "react";
import { FiHelpCircle, FiSettings, FiLogOut } from "react-icons/fi";
import styles from "../styles/Sidebar.module.css";

const Sidebar = ({ user, company, selected, onSelect, showMenuTwo, setShowMenuTwo, onLogout }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className={styles.sidebar}>
      <img src="/iconGM.png" alt="Логотип" className={styles.logo} />

      <div className={styles.userInfo} ref={dropdownRef}>
        <div onClick={() => setShowDropdown(!showDropdown)} className={styles.userClickArea}>
          <img src="/Avatar.png" alt="Аватар" className={styles.avatar} />
          <div className={styles.userText}>
            <p className={styles.name}>
              {user?.name} {user?.surname}
            </p>
            <p className={styles.label}>
              {company?.data?.org?.name || "Личный кабинет"}
            </p>
          </div>
        </div>

        {showDropdown && (
          <div className={styles.dropdown}>
            <button className={styles.dropdownItem}>
              <FiHelpCircle className={styles.icon} />
              Помощь
            </button>

            <button
              className={styles.dropdownItem}
              onClick={() => {
                setShowDropdown(false);
                setShowMenuTwo(true);
              }}
            >
              <FiSettings className={styles.icon} />
              Настройки
            </button>

            <button
              className={styles.dropdownItem}
              onClick={() => {
                setShowDropdown(false);
                onLogout();
              }}
            >
              <FiLogOut className={styles.icon} />
              Выйти из системы
            </button>
          </div>
        )}
      </div>

      {!showMenuTwo && (
        <div className={styles.menu}>
          <button
            className={selected === "analytics" ? styles.active : ""}
            onClick={() => onSelect("analytics")}
          >
            <p
              className={`${styles.analytics} ${
                selected === "analytics" ? styles.active_text : ""
              }`}
            >
              Аналитика
            </p>
          </button>

          <button
            className={selected === "products" ? styles.active : ""}
            onClick={() => {
              onSelect("products");
              setShowMenuTwo(false);
            }}
          >
            <p
              className={`${styles.products} ${
                selected === "products" ? styles.active_text : ""
              }`}
            >
              Товары
            </p>
          </button>

          <button
            className={selected === "realization" ? styles.active : ""}
            onClick={() => onSelect("realization")}
          >
            <p
              className={`${styles.realization} ${
                selected === "realization" ? styles.active_text : ""
              }`}
            >
              Реализация
            </p>
          </button>

          <button
            className={selected === "partners" ? styles.active : ""}
            onClick={() => onSelect("partners")}
          >
            <p
              className={`${styles.counterparties} ${
                selected === "partners" ? styles.active_text : ""
              }`}
            >
              Контрагенты
            </p>
          </button>

          <button
            className={selected === "reports" ? styles.active : ""}
            onClick={() => onSelect("reports")}
          >
            <p
              className={`${styles.reports} ${
                selected === "reports" ? styles.active_text : ""
              }`}
            >
              Отчеты
            </p>
          </button>

          <button
            className={selected === "taxes" ? styles.active : ""}
            onClick={() => onSelect("taxes")}
          >
            <p
              className={`${styles.taxes} ${
                selected === "taxes" ? styles.active_text : ""
              }`}
            >
              Налоги
            </p>
          </button>

          <button
            className={selected === "documents" ? styles.active : ""}
            onClick={() => onSelect("documents")}
          >
            <p
              className={`${styles.documents} ${
                selected === "documents" ? styles.active_text : ""
              }`}
            >
              Документы
            </p>
          </button>

          <button
            className={selected === "greenmagPro" ? styles.active : ""}
            onClick={() => onSelect("greenmagPro")}
          >
            <p
              className={`${styles.greenmagPro} ${
                selected === "greenmagPro" ? styles.active_text : ""
              }`}
            >
              GreenMag Pro
            </p>
          </button>

          <button
            className={selected === "greenmagCashback" ? styles.active : ""}
            onClick={() => onSelect("greenmagCashback")}
          >
            <p
              className={`${styles.greenmagCashback} ${
                selected === "greenmagCashback" ? styles.active_text : ""
              }`}
            >
              GreenMag Cashback
            </p>
          </button>

          <button
            className={selected === "sales" ? styles.active : ""}
            onClick={() => onSelect("sales")}
          >
            <p
              className={`${styles.sales} ${
                selected === "sales" ? styles.active_text : ""
              }`}
            >
              Режим продажи
            </p>
          </button>
        </div>
      )}

      {/* --- SECOND MENU --- */}
      {showMenuTwo && (
        <div className={styles.menuTwo}>
          <button
            onClick={() => setShowMenuTwo(false)}
            className={styles.backButton}
          >
            <p className={styles.back}>На главную</p>
          </button>

          <button
            className={selected === "account" ? styles.active : ""}
            onClick={() => onSelect("account")}
          >
            <p
              className={`${styles.account} ${
                selected === "account" ? styles.active_text : ""
              }`}
            >
              Аккаунт
            </p>
          </button>

          <button
            className={selected === "storages" ? styles.active : ""}
            onClick={() => onSelect("storages")}
          >
            <p
              className={`${styles.storages} ${
                selected === "storages" ? styles.active_text : ""
              }`}
            >
              Склад
            </p>
          </button>

          <button
            className={selected === "finance" ? styles.active : ""}
            onClick={() => onSelect("finance")}
          >
            <p
              className={`${styles.finance} ${
                selected === "finance" ? styles.active_text : ""
              }`}
            >
              Финансы
            </p>
          </button>

          <button
            className={selected === "paymentMethods" ? styles.active : ""}
            onClick={() => onSelect("paymentMethods")}
          >
            <p
              className={`${styles.paymentMethods} ${
                selected === "paymentMethods" ? styles.active_text : ""
              }`}
            >
              Способы оплаты
            </p>
          </button>

          <button
            className={selected === "staff" ? styles.active : ""}
            onClick={() => onSelect("staff")}
          >
            <p
              className={`${styles.staff} ${
                selected === "staff" ? styles.active_text : ""
              }`}
            >
              Сотрудники
            </p>
          </button>
        </div>
      )}
    </div>
  );
};

export default Sidebar;
